<template>
    <div>
        <div v-if="$store.user.userId && $route.path !== '/login/tree' && $route.path !== '/menu'" id="header">
            <div id="logo"></div>
            <TabMenu :menu="$store.menu" />

            <div v-if="$store.showLoadingOverlay" id="status_panel">
                <div id="status_panel_inner">
                    {{ $t($store.loadingText) }}
                </div>
            </div>

            <div v-if="$store.showStatusMessage" id="divStatusMessage" :class="$store.statusType" class="StatusMessage">
                {{ $store.statusText }}
            </div>

            <div id="links">
                <CicButton id="logout" :title="$t('LOGOUT')" @click="logout">
                    {{ $t('LOGOUT') }}
                </CicButton>

                <CicButton id="documents" :title="$t('Documents')" @click="openHelp">
                    {{ $t('Documents') }}
                </CicButton>
                <div
                    v-if="$store.switchMode"
                    id="mode_toggle"
                    :title="$t($store.darkMode ? 'Switch To Light Theme' : 'Switch To Dark Theme')"
                    @click="toggleMode"
                ></div>
            </div>
            <div id="userinfo">
                <ul>
                    <li>{{ $store.user.displayName }}</li>
                    <li>{{ orgDisplayName }}</li>
                </ul>
            </div>
        </div>
        <div v-else id="portal-header" class="unselectable">
            <div id="login-logo"></div>

            <div v-if="$store.user.ownerId" id="links">
                <div v-if="theme" id="mode_toggle" @click="toggleMode"></div>
                <div v-if="$store.helpLink !== ''" id="documents" :title="$t('Documents')" @click="openHelp"></div>
                <div id="logout" :title="$t('LOGOUT')" @click="logout"></div>
            </div>
            <LanguageSelector v-else-if="!$store.showLoadingOverlay" />
        </div>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import { goToHelp } from '@/utils/Help';
    import { logout } from '@/utils/Http';
    import LanguageSelector from './LanguageSelector';
    import TabMenu from './TabMenu';
    import './resources/styles/header.scss';

    export default {
        name: 'AppHeader',
        components: {
            CicButton,
            LanguageSelector,
            TabMenu,
        },
        props: {
            theme: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            orgDisplayName() {
                let name = this.$store.user.ownerName;
                if (this.$store.user.ownerId !== this.$store.user.orgId) {
                    name = name + ' - ' + this.$store.user.orgName;
                }

                return name;
            },
        },
        methods: {
            logout() {
                logout(this.$router);
            },

            openHelp() {
                goToHelp();
            },

            toggleMode() {
                this.$store.darkMode = !this.$store.darkMode;
                localStorage.darkMode = this.$store.darkMode;
            },
        },
    };
</script>
